import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M7,3h8c3.64,0,6.29.52,7.93,1.56A5.39,5.39,0,0,1,25.4,9.5a6.22,6.22,0,0,1-1.08,3.78,4.31,4.31,0,0,1-2.87,1.78v.17a5.7,5.7,0,0,1,3.52,2,6.65,6.65,0,0,1,1.08,4,6.52,6.52,0,0,1-2.54,5.48,11,11,0,0,1-6.89,2H7Zm5.45,10.18h3.16a5.75,5.75,0,0,0,3.21-.69,2.55,2.55,0,0,0,1-2.27,2.25,2.25,0,0,0-1.08-2.11,6.91,6.91,0,0,0-3.42-.65H12.45Zm0,4.32v6.7H16a5.28,5.28,0,0,0,3.32-.86,3.18,3.18,0,0,0,1.07-2.64q0-3.19-4.57-3.2Z"/>';
export var TextBoldOutlineSVG = function TextBoldOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
TextBoldOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TextBoldOutlineSVG);